module.exports = __webpack_public_path__ + "media/touch_of_midas.f403cc89.webm";